import React, { useState, useEffect } from 'react';

import { Dialog, DialogTitle, DialogContent, Button, DialogActions, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getUnitById, permissionOptions, referenceTypes } from '../../utils/Enums';
import { getReferences } from '../../services/SuppliesService';
import { formatMoney } from '../../utils/currency';

const ViewPreparationModal = ({ locationId, open, onClose, preparation }) => {
  
    const { t } = useTranslation();
    const [references, setReferences] = useState([]);
    const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
    const canViewCost = userPermissions.includes(permissionOptions.find(p => p.label === 'VIEW_COST_PRODUCTS').id);

    useEffect(() => {
        if (open) {
            getReferences(locationId).then(data => {
                setReferences(data);
            });
        }
    }, [open]);

    const getReferenceNameById = (id, type) => {
        const ref = references.find(r => r.referenceId1 === id && r.referenceType === type);
        return ref ? ref.referenceName1 : t('not_defined');
    };

    const getReferenceTypeLabel = (type, t) => {
        const referenceMap = {
            [referenceTypes.INSUMO]: t('supply'),
            [referenceTypes.PREPARADO]: t('preparation'),
            [referenceTypes.CATEGORIES]: t('category'),
            [referenceTypes.PRODUCTS]: t('product'),
        };
    
        return referenceMap[type] || t('not_defined');
    };    

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{t('view_preparation')}</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom variant="h6"><span className="roboto-regular">{t('basic_information')}</span></Typography>
                
                <Typography><span className="roboto-regular">{`${t('name')}:`}</span> <span className="roboto-light">{`${preparation.name}`}</span></Typography>
                {canViewCost && <Typography><span className="roboto-regular">{`${t('cost')}:`}</span> <span className="roboto-light">{preparation.cost !== null && preparation.cost !== undefined ? formatMoney(preparation.cost, preparation.costCurrency) : 'N/A'}</span></Typography>}
                <Typography><span className="roboto-regular">{`${t('stock')}:`}</span> <span className="roboto-light">{`${preparation.stock}`}</span></Typography>
                <Typography><span className="roboto-regular">{`${t('minimum_stock')}:`}</span> <span className="roboto-light">{`${preparation.minimumStock}`}</span></Typography>
                <Typography><span className="roboto-regular">{`${t('suggested_stock')}:`}</span> <span className="roboto-light">{`${preparation.suggestedStock}`}</span></Typography>
                <Typography><span className="roboto-regular">{`${t('unit')}:`}</span> <span className="roboto-light">{`${getUnitById(preparation.unit).label}`}</span></Typography>
                <Typography gutterBottom variant="h6" style={{ marginTop: '20px' }}><span className="roboto-regular">{t('items')}</span></Typography>
                <Table size="small">
                <TableHead>
                    <TableRow>
                    <TableCell><span className="roboto-regular">{t('quantity')}</span></TableCell>
                    <TableCell><span className="roboto-regular">{t('unit')}</span></TableCell>
                    <TableCell><span className="roboto-regular">{t('reference_type')}</span></TableCell>
                    <TableCell><span className="roboto-regular">{t('reference')}</span></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {preparation.items.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell><span className="roboto-light">{item.quantity}</span></TableCell>
                            <TableCell><span className="roboto-light">{getUnitById(item.unit).label}</span></TableCell>
                            <TableCell><span className="roboto-light">{getReferenceTypeLabel(item.referenceType, t)}</span></TableCell>
                            <TableCell><span className="roboto-light">{getReferenceNameById(item.referenceId, item.referenceType)}</span></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewPreparationModal;
